import { Typography } from '@material-ui/core';

import TableStyles from './TableStyles';
import { TableCell as TableCellType } from './types';

import { withStyles } from '~/theme/komodo-mui-theme';

type Props = {
  classes: Classes<typeof TableStyles>;
  entry: TableCellType;
  isCentered?: boolean;
  isRightAligned?: boolean;
  isStickyBottom?: boolean;
};

const TableCell = ({
  isCentered: centered = false,
  classes,
  entry,
  isRightAligned: rightAligned = false,
  isStickyBottom = false,
}: Props) => {
  const { disabled = false, text, component, span = 1 } = entry;

  return (
    <div
      className={[
        'flex items-center border-b px-2',
        isStickyBottom ? 'sticky bottom-0 bg-background-primary' : '',
      ].join(' ')}
      data-cy="table-cell"
      style={{ gridColumn: `span ${span}`, pageBreakInside: 'avoid', wordBreak: 'normal' }}
    >
      <div
        className={`${classes.listElementContent} ${centered ? classes.centered : ''} ${
          rightAligned ? classes.rightAligned : ''
        }`}
      >
        {component}
        {text && (
          <Typography
            className={`${classes.text} ${disabled ? classes.disabled : ''} ${
              entry.isNumber ? classes.isNumber : ''
            }`}
            data-cy={`table-cell-${text}`}
            variant="body1"
          >
            {text}
          </Typography>
        )}
      </div>
    </div>
  );
};

export default withStyles(TableStyles)(TableCell);
